

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const NEWSLETTERGETBYID= createAsyncThunk(
  "NewsletterGetById/NewsletterGetById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const NewsletterGetByIdSlice = createSlice({
  name: "NewsletterGetByIdSlice",
  initialState: {
    NewsletterGetById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfNewsletterGetById: (state) => {
        state.NewsletterGetById.loading = false
        state.NewsletterGetById.error = false
        state.NewsletterGetById.data = []
        state.NewsletterGetById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(NEWSLETTERGETBYID.fulfilled, (state, action) => {
      state.NewsletterGetById = {
        ...state.NewsletterGetById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(NEWSLETTERGETBYID.pending, (state, action) => {
      state.NewsletterGetById = {
        ...state.NewsletterGetById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(NEWSLETTERGETBYID.rejected, (state, action) => {
      state.NewsletterGetById = {
        ...state.NewsletterGetById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const NewsletterGetByIdAction = {
    NEWSLETTERGETBYID,
};

export { NewsletterGetByIdAction };
export default NewsletterGetByIdSlice.reducer;
export const {setInitialStateOfNewsletterGetById} = NewsletterGetByIdSlice.actions
